module.exports = __webpack_public_path__ + "6b97fc332b8986b07f8e24ed872f8622.png";